import axios from "axios";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect, useState } from "react";
import { Outlet, Navigate, Link, useLocation } from "react-router-dom";
import { useStateContext } from "../../Context/ContextProvider";
import { IoSettings } from "react-icons/io5";
import { FaPowerOff, FaPlus } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { BsGrid3X3GapFill } from "react-icons/bs";
import Deconnexion from "../Connexion/Logout/Deconnexion";
import fr from "../../image/fr.png"
import en from "../../image/en.png"
import icons from "../../database/icone";
import Footer from "../Footer/Footer";
import { useLanguage } from "../../Context/LanguageContext ";
import EtpCatalogue from "../ETP/AccueilETP/Accueiletp";
import TabsEtp from "../ETP/TabsEtp/TabsEtp";
import ModalEtp from "../ETP/ModalCoursEtp/ModalCoursEtp";
import { useSearch } from "../../Context/SearchContext";
import AppLauncherGrid from "./AppLauncher";

export default function FunctionEtp() {

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [userType, setUserType] = useState(null);
  const [onlineModules, setOnlineModules] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  //zone de recherche
  const { searchTerm, setSearchTerm } = useSearch();
  // animation AOS
  useEffect(() => {
    AOS.init({
      duration: 1000, // durée de l'animation
      once: true,     // l'animation se joue une seule fois
    });
  }, []);

  //beta
  const [isBetaOpen, setIsBetaOpen] = useState(false);
  const toogleBeta = () => {
    setIsBetaOpen(!isBetaOpen);
  }

  const [activeTab, setActiveTab] = useState('disponible');

  const location = useLocation();
  const [data, setData] = useState();

  const { user, token } = useStateContext();

  // affichage formation disponible, en préparation, corbeille
  const [modules, setModules] = useState([]);
  // dropdown déconnexion

  const fetchModules = async () => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem('ACCESS_TOKEN');
      const response = await axios.get('https://catalogue.mg.formafusion.io/api/entreprise/modules', {
        headers: {
          'Authorization': `Bearer ${token}`,
          Accept: 'application/json'
        }
      });
      // Récupération des modules en préparation depuis l'API
      const onlineData = response.data.onlineModules || [];
      setOnlineModules(onlineData);

    } catch (error) {
      console.error("Erreur lors de la récupération:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchModules();
  }, []);

  const handleModuleAdded = (newModule) => {
    const stored = JSON.parse(localStorage.getItem("onlineModules")) || [];
    const updatedStored = [...stored];

    // Chercher le domaine correspondant
    const domainIndex = updatedStored.findIndex(d => d.domaine === newModule.domaine);
    if (domainIndex !== -1) {
      updatedStored[domainIndex].modules.unshift(newModule);
      updatedStored[domainIndex].count_module += 1;
    } else {
      updatedStored.unshift({
        domaine: newModule.domaine,
        modules: [newModule],
        count_module: 1
      });
    }

    setOnlineModules(updatedStored);
    localStorage.setItem("onlineModules", JSON.stringify(updatedStored));
    fetchModules();
  };

  const [isLogout, setLogout] = useState(false);
  const toggleDropdownLogout = () => {
    setLogout(!isLogout);
  }

  // dropdown microservice
  const [isOpen, setOpen] = useState(false);
  const toggleDropdown = () => {
    setOpen(!isOpen);
  };

  //affichage image après une connexion
  const profileBaseUrl = "https://formafusionmg.ams3.cdn.digitaloceanspaces.com/formafusionmg";

  // stockage image en localStorage
  const storeimage = localStorage.getItem("user");
  const sary = storeimage && storeimage !== "undefined" ? JSON.parse(storeimage) : null;

  // confirmation déconnexion
  const [isConfirmLogout, setConfirmLogout] = useState(false)

  //dropdown changement de langue
  const [isLangue, setLangue] = useState(false);
  //const [language, setLanguage] = useState("fr"); // valeur par déf
  const { lang: language, setLang: setLanguage } = useLanguage();
  const toggleDropdownLangue = () => {
    setLangue(!isLangue);
  }
  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    setLangue(false); // referme le menu après sélection
  };

  const flag = language === "fr" ? fr : en;
  const label = language === "fr" ? "FR" : "EN";

  //affichage appLauncher
  const [menuItems, setMenuItems] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get("http://localhost:8000/api/app_launcher");
        setMenuItems(data.data)
      } catch (error) {
        console.log(error)
      }
    }
    fetchData();
  }, []);

  if (!token) {
    return <Navigate to="" />;
  }

  return (
    <>
      <div className="flex flex-col min-h-screen">
        <header>
          <div className="fixed top-0 z-50 w-full bg-white/90 backdrop-blur-lg backdrop-saturate-150 px-5 border-b-100 border border-gray-200 py-5">
            <div className="w-full">
              <nav className="flex flex-wrap justify-between items-center gap-y-4">

                {/* icone+nom de microservice */}
                <div className="inline-flex items-center gap-3">
                  <span className="text-lg">📚</span>
                  <h1 className="text-lg font-semibold text-gray-700">Catalogue</h1>

                  <div
                    className="cursor-pointer text-sm px-3 py-1 font-semibold bg-green-500 text-white rounded-full border border-green-600 shadow-md transition-all duration-300 hover:bg-green-600 hover:shadow-lg"
                    onClick={toogleBeta}
                  >
                    <h1 className="text-xs tracking-wide uppercase">Beta</h1>
                  </div>
                  {/* ouverture beta */}
                  {isBetaOpen && (
                    <div className="absolute top-full mt-2 w-80 bg-white text-sm text-gray-700 p-5 rounded-xl shadow-xl border border-gray-300 z-10 dark:bg-gray-800 dark:text-gray-200 dark:border-gray-700 transition-all duration-300">

                      <h1 className="text-purple-600 dark:text-purple-400 font-semibold text-base mb-2 flex items-center gap-2">
                        🚧 <span>La plateforme est en <span className="underline">BETA ouverte</span> !</span>
                      </h1>

                      <p className="mb-4 leading-relaxed text-gray-600 dark:text-gray-300">
                        Nous travaillons activement pour l'améliorer, et vos retours sont essentiels.
                      </p>

                      <Link
                        to="https://forma-fusion.com/contact/?fbclid=IwZXh0bgNhZW0CMTEAAR4JoY_z7ESPf-9bZO8TjKIz-LxJiai36sATGVmzmvbm7VImq-4KcYAHntV8gA_aem_xukHLAMFFweTLMqxkueCrQ"
                        className="inline-block text-white bg-purple-600 hover:bg-purple-700 transition-colors duration-300 px-4 py-2 rounded-full text-center font-medium dark:bg-purple-500 dark:hover:bg-purple-600"
                        target="_blank"
                      >
                        📩 Contactez-nous ici
                      </Link>
                    </div>

                  )}
                </div>

                {/* Navigation */}
                {/* <Tabs activeTab={activeTab} setActiveTab={setActiveTab} data={data} /> */}
                {(location.pathname === "/etp/catalogue" || location.pathname === "/etp/catalogue/preparationetp" || location.pathname === "/etp/catalogue/corbeilleetp") && (
                  <TabsEtp activeTab={activeTab} setActiveTab={setActiveTab} modules={modules} />
                )}

                {/* Champ de recherche */}
                {(location.pathname === "/etp/catalogue" || location.pathname === "/etp/catalogue/preparationetp" || location.pathname === "/etp/catalogue/corbeilleetp") && (
                  <div >
                    <div className="flex items-center bg-gray-100 border border-gray-300 rounded-lg w-[25em] px-4 py-2">
                      <input
                        type="text"
                        placeholder="Que cherchez-vous ?"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full bg-transparent outline-none text-gray-600 placeholder-gray-400"
                      />
                      <icons.search className="text-gray-400 text-xl" />
                    </div>
                  </div>
                )}

                {/* Bouton d'ajout */}
                {(location.pathname === "/etp/catalogue" || location.pathname === "/etp/catalogue/preparationetp" || location.pathname === "/etp/catalogue/corbeilleetp") && (
                  <div className=" z-50">
                    <button
                      onClick={() => setIsFormOpen(true)}
                      className="bg-green-500 text-white rounded-full w-4 h-4 sm:w-8 sm:h-8  flex items-center justify-center text-3xl shadow-xl   transition-all duration-300 ease-in-out transform hover:scale-110 hover:shadow-2xl"
                    >
                      <FaPlus className="text-white text-2xl" />
                    </button>
                  </div>
                )}

                <ModalEtp
                  show={isFormOpen}
                  handleClose={() => setIsFormOpen(false)}
                  onModuleAdded={handleModuleAdded}
                  userType={userType}
                />

                {/* dropdown déconnexion */}
                {isLogout && (
                  <div className="absolute right-2 top-16 sm:right-4 sm:top-20 w-48 bg-white rounded-xl shadow-lg py-3 ring-1 ring-gray-200 z-50">
                    <div className="px-4 py-2 border-b border-gray-200">
                      <p className="text-sm font-semibold text-gray-900">{user.name}</p>
                      <p className="text-[12px]  text-gray-900">{user.email}</p>
                    </div>

                    <button className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-all">
                      <FaUser className="w-4 h-4" />
                      Gérer mon compte
                    </button>

                    <button className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-all">
                      <IoSettings className="w-4 h-4" />
                      Paramètres
                    </button>

                    <div className="border-t border-gray-200 mt-2" >
                      <button className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-all" onClick={() => setConfirmLogout(true)}>
                        <FaPowerOff className="w-4 h-4" />
                        Déconnexion
                      </button>
                    </div>
                    <Deconnexion showLogout={isConfirmLogout} handleCloseLogout={() => setConfirmLogout(false)} />
                  </div>
                )}

                {/* dropdown applauncher */}
                {isOpen && (
                  <div className="origin-top-right absolute right-0 mt-[47%] w-[493px] sm:w-110 rounded-2xl shadow-xl bg-white focus:outline-none z-30 p-5 border border-gray-100 dark:border-gray-700">

                    <AppLauncherGrid />

                  </div>

                )}

                <div className="flex items-center justify-end gap-4">
                  {/* Changement de langue */}
                  <div className="relative">
                    <div
                      className="cursor-pointer flex items-center gap-1"
                      onClick={toggleDropdownLangue}
                    >
                      <img src={flag} className="w-8 h-8 object-contain rounded-full" alt="Français" />
                      <span>{label}</span>
                    </div>

                    {isLangue && (
                      <div className="absolute mt-2 w-24 bg-white rounded-xl shadow-xl p-2 z-50 text-center left-[1%]">
                        {/* <img src={en} className="w-8 object-contain" alt="English" /> */}
                        <div
                          onClick={() => handleLanguageChange("fr")}
                          className="cursor-pointer hover:bg-gray-100 rounded-lg py-1"
                        >
                          Français
                        </div>
                        <div
                          onClick={() => handleLanguageChange("en")}
                          className="cursor-pointer hover:bg-gray-100 rounded-lg py-1"
                        >
                          Anglais
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Menu (barres) */}
                  <div className="relative">
                    <div
                      className="p-2 rounded-full hover:bg-gray-200 transition cursor-pointer"
                      onClick={toggleDropdown}
                    >
                      <BsGrid3X3GapFill className="text-xl text-gray-600 hover:text-[#A462A4]" />
                    </div>
                  </div>

                  {/* Utilisateur (photo ou initiale) */}
                  <div className="flex items-center space-x-2 cursor-pointer" onClick={toggleDropdownLogout}>
                    {user?.photo ? (
                      <>
                        <div className="w-8 h-8 rounded-full overflow-hidden shadow-md hover:scale-105 transition-transform duration-200">
                          <img
                            src={`${profileBaseUrl}/img/referents/${sary?.photo}`}
                            alt="Profile"
                            className="w-full h-full object-cover"
                          />
                        </div>
                        {/* {sary?.name && (
                        <span className="text-sm font-semibold text-gray-700">{sary.customerName}</span>
                      )} */}
                      </>
                    ) : user?.name ? (
                      <>
                        <button className="w-10 h-10 rounded-full bg-slate-200 text-slate-600 font-semibold text-xl flex items-center justify-center hover:bg-slate-300">
                          {sary?.name?.charAt(0).toUpperCase()}
                        </button>
                        {sary?.name && (
                          <span className="text-sm font-semibold text-gray-700">{sary.name}</span>
                        )}
                      </>
                    ) : null}
                  </div>

                </div>

              </nav>
            </div>
          </div>
        </header>

        <main>
          <div className="flex flex-col min-h-screen">
            {location.pathname === "/etp/catalogue" ? (
              <EtpCatalogue activeTab={activeTab} setActiveTab={setActiveTab} data={data} setData={setData} modules={modules} />
            ) : (
              <Outlet />
            )}
          </div>
        </main>
        <Footer />
      </div>


    </>
  );
}